import { sendErrorToSentry } from '@shared/sentry';
import { fetchInjection, xhrInjection } from './utils';

try {
  fetchInjection();
  xhrInjection();
} catch (e) {
  sendErrorToSentry({ error: e });
}
